import { useState } from "react";
import styles from "./DataAndPrivacy.module.scss";
import SettingsCard from "../SettingsCard/SettingsCard";
import toast from "@/lib/toast";

export interface DeletionRequest {
  id: string;
  memberName: string;
  requestedDate: string;
  gracePeriodEnds: string;
}

const INITIAL_DELETION_REQUESTS: DeletionRequest[] = [
  {
    id: "del-1",
    memberName: "Kavita Nair",
    requestedDate: "28 Jul 2026",
    gracePeriodEnds: "27 Aug 2026",
  },
  {
    id: "del-2",
    memberName: "Sanjay Desai",
    requestedDate: "15 Jul 2026",
    gracePeriodEnds: "14 Aug 2026",
  },
];

export interface DataAndPrivacyProps {
  initialRequests?: DeletionRequest[];
  onCancelRequest?: (request: DeletionRequest) => void;
}

const DataAndPrivacy = ({
  initialRequests = INITIAL_DELETION_REQUESTS,
  onCancelRequest,
}: DataAndPrivacyProps) => {
  const [requests, setRequests] = useState<DeletionRequest[]>(initialRequests);

  const handleCancel = (request: DeletionRequest) => {
    setRequests((prev) => prev.filter((r) => r.id !== request.id));
    toast.success(`Cancelled deletion request for ${request.memberName}`);
    onCancelRequest?.(request);
  };

  return (
    <div className={styles.container}>
      <SettingsCard title="Member Deletion Requests">
        <div className={styles.tableWrapper}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th style={{ width: "38%" }}>MEMBER</th>
                <th style={{ width: "24%" }}>REQUESTED</th>
                <th style={{ width: "24%" }}>GRACE PERIOD ENDS</th>
                <th style={{ width: "14%" }}>ACTION</th>
              </tr>
            </thead>
            <tbody>
              {requests.length === 0 ? (
                <tr>
                  <td colSpan={4} className={styles.emptyState}>
                    No pending deletion requests.
                  </td>
                </tr>
              ) : (
                requests.map((row) => (
                  <tr key={row.id}>
                    <td className={styles.memberName}>{row.memberName}</td>
                    <td className={styles.dateCell}>{row.requestedDate}</td>
                    <td className={styles.dateCell}>{row.gracePeriodEnds}</td>
                    <td>
                      <button
                        type="button"
                        className={styles.cancelActionBtn}
                        onClick={() => handleCancel(row)}
                        aria-label={`Cancel deletion request for ${row.memberName}`}
                      >
                        Cancel
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </SettingsCard>
    </div>
  );
};

export default DataAndPrivacy;
